export default __webpack_public_path__ + "static/media/blue.d687edba.png";